/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlTemplateEmail = "/email-templates";
const urlFolderEmail = "/template-all-folders";
const urlAllTemplates = "/email-all-templates";
const state = {
  templates: [],
  oldTemplates: [],
  templateDetail: {},
  folders: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * Get list students
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getLists({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlTemplateEmail}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_TEMPLATES", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  async getAllTemplate({ commit }) {
    try {
      const response = await axios.get(`${urlAllTemplates}`);
      if (response.status === 200) {
        commit("SET_LIST_ALL_TEMPLATES", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  async getAllTemplateByName({ commit }, name) {
    try {
      commit("SET_LIST_ALL_TEMPLATES_BY_NAME", name);
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  /**
   * Get list folder
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getFolders({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlFolderEmail}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_FOLDERS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  /**
   * Detail
   * @param commit
   * @param id
   * @returns {Promise<{}|*>}
   */
  async detail({ commit }, id) {
    try {
      const response = await axios.get(
        `${urlTemplateEmail}/${id}?include=folder`,
      );
      if (response.status === 200) {
        commit("SET_TEMPLATE_DETAIL", response.data.data);
      }
      return response;
    } catch (e) {
      console.log("exception: ", e);
      return {};
    }
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post(urlTemplateEmail, payload);
  },

  /**
   * Update
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return await axios.put(`${urlTemplateEmail}/${id}`, payload);
  },

  /**
   * Delete
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`${urlTemplateEmail}/${id}`);
  },

  async shareUsers({ commit }, data) {
    return await axios.post(
      `${urlTemplateEmail}/${data.id}/share-users`,
      data.payload,
    );
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async uploadImage({ commit }, payload) {
    return await axios.post("/upload/image", payload);
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async uploadVideo({ commit }, payload) {
    return await axios.post("/upload/video", payload);
  },
};

const mutations = {
  // EDIT_DATA (state, itemId) {
  //   state.students.map(item => {
  //     item.isOpen = false
  //     return item
  //   })
  //   const userIndex = state.students.findIndex((u) => u.id === itemId)
  //   if (userIndex >= 0) {
  //     state.students[userIndex].isOpen = true
  //   }

  // },
  SET_LIST_ALL_TEMPLATES_BY_NAME(state, data) {
    if (data) {
      state.templates = state.templates.filter((item) =>
        item.title.toLowerCase().includes(data.toLowerCase()),
      );
    } else {
      state.templates = state.oldTemplates;
    }
  },
  SET_LIST_ALL_TEMPLATES(state, data) {
    state.templates = state.oldTemplates = data;
  },
  SET_TEMPLATE_DETAIL(state, data) {
    state.templateDetail = data;
  },
  SET_LIST_TEMPLATES(state, data) {
    state.templates = data.items;
    state.pagination = data.pagination;
  },
  SET_LIST_FOLDERS(state, data) {
    state.folders = data;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
